import React from 'react';

type IconProps = {
  style?: React.CSSProperties;
};

// react-color depends on this icon path from @icons/material, but that package
// version does not ship the file. Provide a tiny compatible fallback component.
export default function UnfoldMoreHorizontalIcon({ style }: IconProps) {
  return (
    <span aria-hidden="true" style={style}>
      <svg viewBox="0 0 24 24" width="24" height="24" focusable="false">
        <path d="M11 6l-4 4h3v4H7l4 4 4-4h-3v-4h3l-4-4z" />
      </svg>
    </span>
  );
}
